import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import * as UI from '@brewlogix/blx-ui'
import { snakeToPascal } from 'src/util/helpers'
import Label from '../Label'

const KeyIngredients: React.FC = () => {
    const { productData } = useBrewDetailStore()
    const keyIngredients =
        productData?.ingredients?.filter((item) => item?.type?.toString() === 'KeyIngredients') ||
        []

    return (
        <div className='flex flex-col gap-2'>
            <Label labelText='Key Ingredients' />
            <div className='flex flex-wrap gap-1'>
                {keyIngredients.map((item) => (
                    <UI.Pill
                        key={item?.title}
                        label={snakeToPascal(item?.title)}
                        customClasses='bg-gray-100 text-base py-1 px-3 text-gray-500'
                    />
                ))}
            </div>
        </div>
    )
}

export default KeyIngredients
